import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'

export const CMPageAATests = () => {
  useEffect(() => {
    trackExperimentViewed('cm_aa_1')
    trackExperimentViewed('cm_aa_2')
    trackExperimentViewed('cm_aa_3')
    trackExperimentViewed('cm_aa_4')
    trackExperimentViewed('cm_aa_5')
    trackExperimentViewed('cm_aa_6')
    trackExperimentViewed('cm_aa_7')
    trackExperimentViewed('cm_aa_8')
    trackExperimentViewed('cm_aa_9')
    trackExperimentViewed('cm_aa_10')
    trackExperimentViewed('cm_aa_11')
    trackExperimentViewed('cm_aa_12')
    trackExperimentViewed('cm_aa_13')
    trackExperimentViewed('cm_aa_14')
    trackExperimentViewed('cm_aa_15')
    trackExperimentViewed('cm_aa_16')
    trackExperimentViewed('cm_aa_17')
    trackExperimentViewed('cm_aa_18')
    trackExperimentViewed('cm_aa_19')
    trackExperimentViewed('cm_aa_20')
  }, [])

  return null
}
